export default {
  welcomeLogin: "Welcome to log in",
  operate: "Operation", //操作
  downloadApp: "Download App", //下载APP
  serialNum: "No.", //序号
  departStation: "Boarding", //上站
  getOnTheStation: "Boarding point", //上站点
  getOffTheStation1: "Alighting", //下站
  getOffTheStation: "Alighting point", //下站点
  departTime: "Departure time", //发车时间
  seatNum: "Seat number", //座位号
  wayType: "Round-trip Type", // 往返类型
  ticketCategory: "Ticket type", // 票种
  ticketFaceVal: "Fare", //票价
  type: "Type", //类型
  name: "Name", //姓名
  areaCd: "Area code", //区号
  tel: "Contact information", //联系方式
  idType: "Type of identification", //证件类型
  idNo: "Identification number", //证件号码
  noData: "No data", //暂无数据
  schedulePrice: "Current ticket fare", //新票售价
  priceDiff: "Pay fare difference", //补差价
  chineseMain: "Mainland", //大陆
  hongKong: "Hong Kong", //香港
  macao: "Macau", //澳门
  bigVehicle: "Large vehicle", //大巴
  smallVehicle: "Small vehicle", //小车
  oneWay: "One-way", //单程
  priceRules: "Pricing rule", //价格规则
  roundTrip: "Round-trip", //往返
  departureCity: "Departure city", // 出发城市
  departure: "Departure", //出发
  arrival: "Arrival", //到达
  destinationCity: "Arrival city", // 到达城市
  departureDate: "Departure date", //出发日期
  returnDate: "Return date", //返程日期
  selectDate: "Select Date", //选择日期
  passengersAmount: "Number of passengers", //乘客人数
  inquiry: "Search", //查询
  save: "Save", //保存
  add: "Add", //新增
  export: "Export", //导出
  advancedSearchAction: "Advanced search", //高级搜索
  totalNumberTickets: "Total number of tickets purchased", //购票总张数
  totalAmountTicket: "Total amount of ticket purchase", //购票总金额
  currency: "Currency", //币种
  ticketDetails: "Ticket details", //车票明细
  departTrip: "Outbound", //去程
  returnTrip: "Return", //返程
  purchaseQuantity: "Purchase quantity", //购买数量
  number: "Number", //数量
  scheduleInfo: "Schedule information", //班次信息
  selectSeat: "Seat selection", //选座
  copyDownward: "Copy downward", //向下复制
  refresh: "Refresh", //刷新
  unlockOcc: "Release seat lock", //解除锁位
  isLocks: "Release all seat locks", //是否解除所有锁位
  balance: "Account balance", //账户余额
  dateOfUse: "Date of use", //使用日期
  ticketSection: "Ticket section", //票段
  purchasePayAcc: "Prepaid ticket issuance", //预付款出票
  purchaseBuyAcc: "Buyout account ticket issuance", //买断账户出票
  purchaseMonthlySett: "Monthly settlement ticket issuance", //月结出票
  fromDepartStation: "No schedule from depart station", //当前去程站点无班次
  shouldBeLater: "Return date shall be later than departure date", //返程日期必须大于去程日期
  noReturnStation: "No available schedules at current return station", //当前返程站点无班次
  pleaseSelectFirstly: "Please select outbound seat first", //请先选择去程座位
  ticketmMsg: "Return tickets cannot exceed the number of outbound tickets", //返程车票不能多于去程车票
  schedule: "Schedule", //班次
  unabletomatch: "Unable to match corresponding outbound trip", //未能匹配到相应去程
  allUnlocked: "All seat locks released successfully", //解除所有锁位成功
  modifyPriceSourceSuccess: "Pricing rule modified successfully", //修改价格规则成功
  modifyTicketTypeSuccess: "Ticket type modified successfully", //修改票种成功
  areaCode: "Please select your phone area code", //请选择手机所属区号
  pleaseFillTel: "Please enter contact information", //请填写联系方式
  purCompleted: "Order placed successfully", //已成功下单
  seatsOccupied: "Seat locked", //已锁座
  selectType: "Select type", //选择类型
  selectTicketCate: "Select ticket category", //选择票种
  fillIn: "Please enter", //请输入
  moreThanNum: "8 or more persons", //8 人以上
  saveDdefault: "Confirm saving departure/arrival city and station as default?", //确认保存出发/到达城市、站点作为默认项？
  saved: "Saved successfully", //保存成功
  pleaseCity: "Please select city before searching", //请选择城市后查询
  countdown: "Countdown", //倒计时
  showDepartCity: "Displayed after selecting departure city", //选择出发城市后显示
  showArriveCity: "Displayed after selecting arrival city", //选择到达城市后显示
  remainingTickets: "Available tickets", //余票
  openTicket: "Open ticket", //Open票
  openTicketPrice: "Original ticket fare", //原票价值
  authorizedPrice:
    "No price configured or no sales permission for this schedule", //当前班次未配置价格或没有销售权限
  scheduleFirstly: "Please select outbound schedule time first", //请先选择去程班次时间
  later: "Return departure time cannot be earlier than outbound", //返程开车时间不可小于去程
  ticketSales: "Ticket sales", //车票销售
  purchase: "Purchase", //出票
  chargeDetails: "Fee details", //收费明细
  purchaseInformation: "Purchase information", //购买信息
  pay: "Payment", //支付
  total: "Total", //合计
  supplementaryOrLuggage: "Additional ticket/baggage ticket", //附加票/行李票
  baggageTicket: "Baggage ticket", //行李票
  additionalTicket: "Additional ticket", //附加票
  orderInfo: "Order information", //订单信息
  ticketTotalPrice: "Total ticket amount", //车票总金额
  baggagesTotalPrice: "Total baggage ticket amount", //行李票总金额
  additionalsTotalPrice: "Total additional ticket amount", //附加票总金额
  couponTotalPrice: "Total cash voucher amount", //现金券总金额
  couponNumber: "Cash voucher number", //现金券编号
  addAdditionalTicketOrBaggageTicket: "Add additional ticket / baggage ticket", //添加附加票
  success: "Success", //成功
  ticketNumber: "Ticket number", //车票号
  serialNumber: "Number", //编号
  discountAmount: "Discount amount", //优惠金额
  netPrice: "Receivable amount", //应收金额
  collection: "Collect payment", //收款
  change: "Change", //找零
  executePurchase: "Execute sale", //执行销售
  connectionFailed: "Connection failed", //连接失败
  printing: "Printing will begin soon", //打印即将开始
  reminder: "Reminder", //提示
  notBluetooth: "Bluetooth printer not connected. Please confirm connection", //检测到尚未连接蓝牙打印机，请确认是否连接
  connect: "Connect", //去连接
  noNeed: "Not required", //不需要
  complimentaryTickets: "Complimentary ticket", //赠票
  confirmDel: "Delete?", //是否删除
  delConfirm: "Delete confirmation", //删除确认
  delete: "Delete", //删除
  confirm: "Confirm", //确定
  cancel: "Cancel", //取消
  chineseID: "Mainland China ID card", //内地身份证
  hongKongID: "Hong Kong ID card", //香港身份证
  macaoID: "Macau ID card", //澳门身份证
  hkAndMacaoPermit: "Mainland Travel Permit for Hong Kong and Macau Residents", //港澳通行证
  hkAndMacaoResidents:
    "Mainland Return Permit for Hong Kong and Macau Residents", //港澳回乡证
  taiwanResidents: "Taiwan Compatriot Permit", //台湾通行证
  chinesePassport: "Mainland passport", //内地护照
  hkPassport: "Hong Kong passport", //香港护照
  macaoPassport: "Macau passport", //澳门护照
  otherID: "Other identification", //其他证件
  adult: "Adult ticket", //成人票
  elder: "Senior ticket", //长者票
  child: "Child ticket", //小童票
  baby: "Infant ticket", //婴孩票
  student: "Student ticket", //学生票
  selected: "Selected", //选中
  sold: "Sold", //已售
  reserved: "Reserved", //预留
  pleaseInTicket: "Please enter the ticket segment first", //请先输入票段
  pleaseInCash: "Please enter the cash coupon first", //请先输入现金券
  orderInquiry: "Order inquiry", //订单查询
  orderNumber: "Order number", //订单号
  productType: "Product type", //产品类型
  productSegmentation: "Product segmentation", //产品细分
  characteristic: "Characteristic", //特性
  orderType: "Order type", //订单类型
  batchTrips: "Batch retrieve return trips", //为已勾选车票，批量选择返程时间
  salesUnit: "Sales unit", //销售单位
  orderStatus: "Order status", //订单状态
  completed: "Completed", //已完成
  orderDate: "Order date", //下单日期
  to: "To", //至
  retrieveTrip: "Retrieve return trip", //为此车票选择返程时间
  orderTime: "Order time", //下单时间
  orgStructure: "Organizational structure", //组织机构
  transactionAmount: "Transaction amount", //交易金额
  agentTranAmount: "Agent transaction amount", //代理交易金额
  freeTickets: "Free Tickets", //赠票票段
  totalDiscountAmount: "Total discount amount", //优惠总金额
  handPurchaseOrder: "Hand-writing tickets purchase order", //手写票销售订单
  externalSystemOrder: "External System Order", //系统外订单
  fareSupplementOrder: "Fare Supplement Order", //补价票订单
  fareSupplementRefundOrder: "Fare Supplement Refund Order", //补价票退票订单
  select: "Please select", //请选择
  productName: "Product name", //产品名称
  offerName: "Offer name", //优惠名称
  transactionInfo: "Transaction information", //交易信息
  salesman: "Salesman", //销售员
  PrepaymentAndMonthly: "Prepayment / Monthly settlement", //预付款账户/月结账户支出
  buyoutAccount: "Buyout account", //买断账户
  buyoutAccountPay: "Buyout account", //买断账户支出
  ticketInformation: "Ticket information", //车票信息
  reschedule: "Reschedule", //改签
  refund: "Refund", //退票
  ticketStatus: "Ticket status", //车票状态
  sendingMessage: "sending a text message", //发送短信
  sendTime: "Send time", //发送时间
  salesTime: "Sales time", //销售时间
  selectShiftAndDisplay: "Select a shift and display", //选择班次并显示
  printerFailed: "Printer connection failed", //打印机连接失败
  refundInfo: "Refund information（agent & passenger）", //退款信息（代理对乘客）
  rebookedTicketPriced:
    "Rebooked ticket priced by the higher one of original ticket and rebooked ticket", //改签车票按照原票和改签后票价的最高面额计算
  refundFee: "Refund service fee", //退票手续费
  refundAmount: "Refund amount", //应退金额
  amount: "Amount", //金额
  refundDetailamount: "Refund detail（agent & KC）", //退款明细（代理对冠忠）
  ticketPreview: "Ticket preview", //车票预览
  startPrinting: "Start printing", //开始打印
  TSCNotConnected:
    "The TSC desktop printer is not connected. Please check the power supply, whether the printer program is started, the usb connection cable or the installation status!", //TSC台式打印机未连接，请检查电源、打印机程序是否启动、usb连接线或安装状态!
  USBNotFound:
    "The USB device was not found. Please operate after connecting the USB!", //没有找到USB设备，请连接USB后操作!
  WebSocketConnectionFailed:
    "WebSocket connection failed, please refresh the page and proceed with the operation", //WebSocket 连接失败，请刷新页面后进行操作
  pleaseUsingtUsb: "Please connect using the usb interface", //请使用usb接口连接
  RefundOriginal: "Refund through the original payment channel", //原支付渠道退回
  pleaseConnectUsb: "Please connect the usb", //请连接usb
  pleaseConnectUsbprinter: "Please connect the usb printer", //请连接USB打印机
  pleaseConnectPrinter: "Please connect the printer", //请连接打印机
  pleaseConnectBluetooth: "Please connect Bluetooth", //请连接蓝牙
  bluetoothPrinter: "Bluetooth printer", //蓝牙打印机
  IEPrinter: "IE printer", //IE打印
  expiryDate: "Expiration date", // 使用有效期
  groupTicketPrice: "Fare (group ticket)", //票价(团体票)
  includingTicketPrice: "Fare (including additional ticket fare)", //票价（含附加票价）
  passenger: "Passenger", //乘客
  groupTicketAmount: "Number of group tickets", //团体票人数
  noSpecificSeat: "Non-reserved seating", //不按座位号乘车
  groupTicket: "Group ticket", //团体票
  people: "Persons", //人
  oneWayOpenTicket: "One-way open ticket", //单程open票
  ticketNumberBinded: "Bind ticket number", //绑定车票号
  baggageTicketNumber: "Baggage ticket number", //行李票号
  supplementalTicketNumber: "Supplemental ticket number", // 补价票号
  supplementalTicketPrice: "Supplemental ticket price", // 补价票价
  baggageTicketPrice: "Baggage fare", //行李票价
  charteredTicketNumber: "Charter ticket number", //包车票号
  orderDealer: "Order creator", //下单人
  onboardingAmount: "onboarding amount", //乘车人数
  close: "Close", //关闭
  refundTime: "Refund time", //退票时间
  kcBusGroupMember: "A Member of Kwoon Chung Bus Group", //冠忠巴士集團成員
  TicketingSystem: "Ticketing system", //票务系统
  language: "language", //语言
  modifyPrintStatus: "Modify print status", //修改打印状态
  printStatus: "Print status", //打印状态
  qrCodeBoarding: "QR Code Boarding", //二维码乘车
  pleaseSelectReason: "Please select reason", //请选择原因
  clear: "Clear", //清空
  rebooked: "Rebooked", //已改签
  refunding: "Refunding", //退款中
  notReserved: "Not reserved(open ticket)", //open票未取位
  openReserved: "Reserved(open ticket)", //open票已取位
  printerOfPaper: "Printer out of paper", //打印机不出纸
  printingMsg: "Printing is not clear,  ticket invalid", //打印不清晰，车票作废
  printingSystemMsg: "Printing failed due to system issues", //系统问题导致未成功打印
  connectionMsg: "Ticket issuing failed due to internet connection", //网络问题导致无法出票
  other: "Other", //其他
  cash: "Cash", //现金
  channelMsg: "Refund with cash/original payment channel", //现金、原支付渠道退回
  ticketInquiry: "Ticket inquiry", //车票查询
  associatedMsg: "Round-trip ticket number associated", //关联往返车票号
  passengerInfo: "Passenger information", //乘客信息
  scheduleNumber: "Schedule number", //班次号
  vehicleSize: "Vehicle Size", // 车型
  drivingDate: "Travel date", //开车日期
  generalAndSubAgent: "Main agent + Sub-agent", //总代理+子代理
  subAgentName1: "Sub agent name", //子代理名称（繁体）
  pleaseEnterLoginID: "Please enter employee account", //请输入员工账号
  pleaseEnterPassword: "please enter password", //请输入密码
  pleaseEnterIDeode: "Please enter verification code", //请输入验证码
  login: "Log in", //登录
  home: "Home", //首页
  checkMsg: "8–20 characters; cannot be all numbers", //8-20位的字符，不可以纯数字
  incorrectIdentifyingCode: "Please enter the correct verification code", //请输入正确的验证码
  commitMsg: "Incorrect information submitted; please fill in as required", //提交信息有误，请按要求填写
  pleaseLogInAgain: "Please log in again", //请重新登录
  quitConfirm: "Quit confirm", //退出确认
  pleaseEnterOldPassword: "Please enter old password", //请输入旧密码
  pleaseEnterNewPassword: "Please enter new password", //请输入新密码
  pleaseEnterConfirmPassword: "Please enter confirm password", //请输入确认密码
  passwordNotMatch: "Password not match", //密码输入不一致
  modifySuccessReLogin: "Modify success, please log in again", //修改成功，请重新登录
  accountInfo: "Account information", //账号信息
  basicInfo: "Basic information", //基本信息
  messageNotification: "Message notification", //消息通知
  title: "Title", //标题
  content: "Content", //内容
  publishTime: "Publish time", //发布时间
  modifyPassword: "Modify password", //修改密码
  oldPassword: "Old password", //旧密码
  newPassword: "New password", //新密码
  confirmPassword: "Confirm password", //确认密码
  submit: "Submit", //提交
  loginAccount: "account", //登录账号
  password: "Password", //密码
  verifyCode: "Verify code", //校验码
  logout: "Logout", //退出登录
  afterQuitYouNeedToLogInAgain: "After quit, you need to log in again", //退出后需重新登录，请确认是否退出当前登录
  Error404: "Request returned 404 error", //请求发生404错误
  error500: "Request returned 500 error", //请求发生500错误
  connectionTimedOut: "Request timed out", //请求超时
  networkError: "Network error", //网络异常
  requestFailed: "Request failed", //请求失败
  pleaseConnectUSB: "Please connect via USB port!", //请使用
  charteredTicket: "Charter ticket", //包车票
  oneDayUseOnly: "Valid for today only", //仅当天有效
  HZMBridgeIsland: "Hong Kong-Zhuhai-Macao Artificial Island", //港珠澳人工岛
  ShatoujiaoExpress: "Sabah Express", //沙巴特快
  hotline: "Service Hotline", //服务热线
  passengerCopy: "Passenger stub", //乘车联
  reimbursementCopy: "Reimbursement stub", //报销联
  intermodalityCopy: "Transfer stub", //转乘联
  connectingCopy: "Connecting stub", //换乘联
  stubCopy: "Stub", //存根联
  seatMsg: "Non-reserved seating", //不按座位乘车
  rufundRebookNot: "No refunds or exchanges", //不退不改
  printingError: "Print error, reason", //打印错误，原因
  transactions: "Payment method:", //支付方式：
  invalidCopy: "This stub is invalid", //此联无效
  route: "Route", // 路线
  onlyForEachTicket: "Only one piece of luggage allowed per ticket", //每票只限一件行李
  retail: "Ticket office", //门市
  onlyForIE:
    "This feature is only supported in IE, please switch to IE browser for operation", //此功能仅支持IE浏览器，请切换到IE浏览器进行操作
  systemError: "System error", //后台错误
  returnOpenTicket: "Return open ticket", //返程open票
  refundVoucher: "Refund voucher", //退票凭证
  includeDisabledOrganization: "Include disabled organization", //是否包含已停用组织
  includeMore: "Include more", //是否自动勾选上下级
  canInputFilter: "Can input filter", //可输入过滤
  requestError: "Request error", //请求错误
  changeTicketType: "Change ticket type", //改变票种类型
  returnTicketFetch: "Return trip seat selection", //返程取位
  arrivalDate: "Arrival date", //到达日期
  closeRefundPrintDialog: "Close refund print dialog", // 关闭退票打印弹窗
  autoFillTicketNumber: "Automatically fill in the ticket number",
  purchaseDate: "Purchase Date", //购买日期
  rechargeQuantity: "Recharge Quantity", //增值数量
  availableQuantityMaster: "Available Quantity (Master Agent)", //可用数量 （总代理）
  availableQuantityTotal: "Available Quantity (Master + Sub Agents)", //可用数量 （总代理+子代理）
  availableQuantity: "Available Quantity", // 可用数量
  departurePriceArea: "Departure Price Area", // 出发价格区域
  arrivalPriceArea: "Arrival Price Area", // 到达价格区域
  availableAmountAfterChange: "Available Amount - After Change", // 可用数量-变动后
  buyoutNumber: "Buyout Number", // 买断编号
  showAfterSchedule: "Displayed after selecting schedule", //选择班次后显示
  designated: "Designated", //指定
  checked: "Ticket checked", //已验票
  adult2: "Adult", //成人
  elder2: "Senior", //长者
  child2: "Child", //小童
  baby2: "Infant", //婴孩
  student2: "Student", //学生票
  ticketType: "Ticket type", //票类
  pleaseSelectTickets: "Please select tickets for operation", //请勾选车票进行操作
  onlyReturnOpen: "Only return open tickets can be selected at the same time", //仅能同时选择返程
  sameRoute: "Please select tickets of the same route for operation", //请选相同线路车票操作
  baggagesTotalPrice2: "Total baggage ticket amount", //行李票总金额
  additionalsTotalPrice2: "Total additional ticket amount", //附加票总金额
  cashVoucherInvalid: "Cash voucher, this stub is invalid", //现金券，此联无效
  printingException: "Print exception, reason", //打印异常，原因
  maxPassengers: "Maximum number of passengers selected", //已达最大可选人数
  confirmClosePopup: "Confirm closing the popup?", //确定关闭弹窗？
  pleaseSelectStation: "Please select a stop before confirming", //请选择站点后再确定
  pleaseSelectReturnSchedule:
    "Please select the return trip schedule before confirming", //请选择返程班次后再确定
  noRoute: "This schedule has no route", //该班次无路线
  pleaseSelectSeat: "Please select a seat before submitting", //请选择座位后进行提交
  websocketFailed:
    "WebSocket connection failed. Please refresh the page and try again", //WebSocket
  noUSBDevice:
    "No USB device detected. Please connect a USB device and try again!", //没有找到
  tscPrinterNotConnected:
    "TSC desktop printer not connected. Please check the power, printer program status, USB cable, or installation!", //TSC
  changeTrip: "Change trip", //改行程
  onceSold: "Once sold", //一经销售
  hkAndHZMBridge: "Hong Kong and HZM Bridge section", //香港及港珠澳大桥段
  seatNum2: "Seat number:", //座号：
  destination: "Destination:", //目的地：
  date: "Date", //时间：
  boardingPoint: "Boarding point:", //上车点：
  businessException: "Business exception", //业务异常
  missingInputParameter: "Missing input parameter", //入参缺失
  systemException: "System error", //系统异常
  invalidParameterType: "Invalid parameter type", //参数类型错误
  requestBodyCannotBeEmpty: "Request body cannot be empty", //请求体不可为空
  invalidFieldType: "Invalid field type", //字段类型错误
  aggResultCodeFile: "AggResultCode file", //AggResultCode文件
  cannotFindPriceForStop: "Cannot find the price for the selected stop", //找不到站点所属价格
  cannotOperateOutsideAgency:
    "You cannot operate orders or tickets outside your agency's system", //不能操作非本代理体系下的订单车票
  failedToObtainAgencyCredentials: "Failed to obtain agency credentials", //代理身份获取失败
  pleaseSelectAgencySettlementMethod:
    "Please select an agency settlement method", //请选择代理结算方式
  failedToPlaceOrderFromAgencyInventory:
    "Failed to place order from agency inventory", //代理库存下单失败
  ticketSettlementTypeMismatch:
    "The ticket settlement type does not match the current account", //车票结算类型与当前接口账号所属不符
  originalPaymentMethodInconsistent:
    "The original payment method for the tickets is inconsistent. Please handle them separately", //车票原支付方式不一致，请分开操作
  noSalesPermissionForStop: "No sales permission for this stop", //没有当前站点的销售权限
  insufficientSalesPermissions: "Insufficient sales permissions", //销售权限不够
  pleaseSelectDepartureScheduleDateTime:
    "Please select the departure schedule date and time", //请选择去程班次日期和时分
  pleaseSelectReturnScheduleDateTime:
    "Please select the return schedule date and time", //请选择返程班次日期和时分
  jointRoutesCannotRescheduleAcrossLines:
    "Joint Guangdong-Hong Kong routes cannot be rescheduled across lines", //粤港联营班次不能跨路线改签
  ticketStandardPriceNotSet: "Ticket standard price not set", //车票标准价未设置
  productNotEligibleForReturn:
    "This product is not eligible for return or refund", //此商品不支持退货退款
  pleaseEnterPassengerName: "Please enter the passenger's name", //请填写乘客姓名
  pleaseEnterPassengerMobile: "Please enter the passenger's mobile number", //请填写乘客手机号
  pleaseEnterPassengerID: "Please enter the passenger's ID number", //请填写乘客证件号
  pleaseEnterPassengerEmail: "Please enter the passenger's email address", //请填写乘客email
  tourProductTicketsCannotBeRefundedIndividually:
    "Tourism products tickets cannot be refunded individually", //旅游产品车票不能单独退
  outboundInfoCannotBeEmpty: "Outbound information cannot be empty", //去程信息不能为空
  returnInfoCannotBeEmpty: "Return information cannot be empty", //返程信息不能为空
  invalidOutboundInfoSelected: "Invalid outbound information selected", //去程信息选择错误
  invalidReturnInfoSelected: "Invalid return information selected", //返程信息选择错误
  productNotFound: "Product not found", //未找到产品
  productExpired: "Product has expired", //产品已失效
  noTicketInfoUnderBundle:
    "No ticket information found under the bundled product", //未找到打包产品下的车票信息
  routeNotFound: "Route not found", //路线不存在
  pickupDateIncorrect: "Pickup date is incorrect", //取票日期有误
  passengerNameEnglish38:
    "Passenger name shall be in English and less than 38 characters", //乘客姓名必须为英文并且小于38位字符
  emailFormatOrLength: "Invalid email format or exceeds 20 characters", //邮箱格式错误或者超出20个字符限制
  mobileFormatError: "Invalid mobile number format", //手机号格式错误
  usageDateExceedsValidity: "Usage date exceeds validity period", //使用日期超出有效期
  exchangeRateNotConfigured:
    "Exchange rate not configured. Please configure the exchange rate first", //汇率未配置，请先配置汇率
  agentCannotRefundTourProduct:
    "Agents cannot process refunds for tourism products", //代理不可操作旅游产品退款
  failedToReserveSeatsForPackage: "Failed to reserve seats for package tickets", //套票占座失败
  incorrectRouteForPackage: "Incorrect route selection for package tickets", //套票路线选择有误
  incorrectUserTypeForTourProduct:
    "Incorrect user type selected for tourism products allocation. Only agencies or management organizations are allowed", //旅游产品所选分配用户类型错误，只能选择管理机构或代理
  apiOrderResultCodeFile: "ApiOrderResultCode file", //ApiOrderResultCode文件
  orderException: "Order exception", //下单异常
  authenticationResultCodeFile: "AuthenticationResultCode file", //AuthenticationResultCode文件
  missingApiAuthParams: "Missing API authentication parameters", //接口身份认证参数缺失
  apiAuthFailed: "API authentication failed", //接口身份认证失败
  apiAccountNotActivated: "API account not activated", //接口账号未开通
  failedToObtainApiUserInfo: "Failed to obtain API user information", //接口用户信息获取失败
  apiRequestTimestampExpired: "API request timestamp expired", //接口请求时间戳过期
  userNoAccess: "User does not have access permission", //用户没有访问权限
  consoleRespCodeFile: "ConsoleRespCode file", //ConsoleRespCode文件
  supplierNotFound: "Supplier not found", //供应商不存在
  financeRespCodeFile: "FinanceRespCode file", //FinanceRespCode文件
  depositSlipNotFound: "Deposit slip not found", //存款单不存在
  settlementPriceMismatch:
    "Settlement price does not match total counter receipts", //结算价和柜台收款总额不一致
  dataMismatchRefresh: "Data mismatch. Please refresh and try again", //提交数据和系统数据不一致，请刷新后重试
  crossCurrencyRepaymentNotSupported:
    "Cross-currency repayment is not supported", //暂不支持跨币种还款
  repaymentAmountMismatch: "Repayment amount does not match deposit amount", //还款金额和存款金额不一致
  insufficientRepayableAmount: "Insufficient remaining repayable amount", //剩余可还款额不足
  repaymentMustNotExceedRemaining: "Repayment must not exceed remaining amount", //当前还款额需小于等于剩余可还款额
  preApprovalFormNotFound: "Pre-approval form not found", //预审单不存在
  formsRespCodeFile: "FormsRespCode file", //FormsRespCode文件
  statisticalRouteNotFound: "Statistical route not found", //统计路线不存在
  baseRouteNotFound: "Base route not found", //基础路线不存在
  lineRespCodeFile: "LineRespCode file", //LineRespCode文件
  insufficientRemainingTickets: "Insufficient remaining tickets", //余票不足
  reservedSeatsTimedOut:
    "Selected reserved seats have timed out and been released", //所选占座已超时释放
  itineraryInfoNotFound: "Itinerary information not found", //行程信息不存在
  seatUnavailable: "Seat unavailable", //座位不可用
  failedToRevertOrderSeatLock:
    "Failed to revert order seat lock to regular seat reservation", //订单锁座回退到普通占座失败
  currentScheduleStatusUnavailable: "Current schedule status unavailable", //当前班次状态不可用
  seatTemplateUpdated: "Seat template updated, please reselect", //座位模板已更新，请重新选择
  scheduleUnavailable:
    "This schedule is unavailable due to special circumstances. Please choose another.", //班次因特殊情况，已改为不可售，请购买其他班次
  prepaidAccount: "Prepaid account", //预付款账户
  allocate: "Allocate", //分配
  recover: "Recover", //回收
  transfer: "Transfer", //转移
  agentId: "Agent ID", //代理编号
  agentNameSimplified: "Agent name (Simplified)", //代理名称（简体）
  agentNameTraditional: "Agent name (Traditional)", //代理名称（繁体）
  agentLevel: "Agent level", //代理级别
  mainAgent: "Main agent", //总代理
  viewDetails: "View details", //查看明细
  totalPrincipal: "Total principal", //本金总额
  totalAvailable: "Total available", //可用总额
  totalBonusRate: "Total bonus rate", //总赠送率
  totalDiscountRate: "Total discount rate", //总折扣率
  appreciationRecords: "Appreciation records", //增值记录
  operationTime: "Operation time", //操作时间
  operator: "Operator", //操作人
  principalAppreciation: "Principal appreciation", //本金增值
  bonusRate: "Bonus rate", //赠送率
  totalAppreciation: "Total appreciation", //增值总额
  discountRate: "Discount rate", //折扣率
  changeRecords: "Change records", //变动记录
  changeType: "Change type", //变动类型
  totalAvailableBeforeChange: "Total available (before change)", //可用总额-变动前
  totalAvailableChange: "Total available (change)", //可用总额-变动
  totalAvailableAfterChange: "Total available (after change)", //可用总额-变动后
  allocationRecords: "Allocation records", //分配记录
  subAgentId: "Sub-agent ID", //子代理编号
  subAgentIdTraditional: "Sub-agent ID (Traditional)", //子代理编号（繁体）
  subAgentIdEnglish: "Sub-agent ID (English)", //子代理编号（英文）
  totalAvailableAllocated: "Total available - allocated", //可用总额-分配额
  operationDate: "Operation date", //操作日期
  subAgentName: "Sub-agent name", //子代理名称
  totalAvailableBeforeAllocation: "Total available - before allocation", //可用总额-分配前
  totalAvailableAfterAllocation: "Total available - after allocation", //可用总额-分配后
  recoveryRecords: "Recovery records", //回收记录
  totalAvailableBeforeRecovery: "Total available - before recovery", //可用总额-回收前
  totalAvailableAfterRecovery: "Total available - after recovery", //可用总额-回收后
  totalAvailableRecoveredAmount: "Total available - recovered amount", //可用总额-回收额
  transferRecords: "Transfer records", //转移记录
  transferIn: "Transfer in", //转入
  transferOut: "Transfer out", //转出
  totalAvailableTransferredAmount: "Total available - transferred amount", //可用总额-转移额
  transferringSubAgentName: "Transferring sub-agent name", //转出子代理名称
  receivingSubAgentName: "Receiving sub-agent name", //转入子代理名称
  transferringSubAgentId: "Transferring sub-agent ID", //转出子代理编号
  totalAvailableTransferOutAmount: "Total available - transfer out amount", //可用总额-转出额
  receivingSubAgentId: "Receiving sub-agent ID", //转入子代理编号
  enterTicketInfoForQuery: "Enter ticket information for query", //输入车票相关信息进行查询
  paymentOrderType: "Payment order", //支付订单
  refundOrderType: "Refund order", //退款订单
  multiTypeOrderType: "Multi-type order", //多类型订单
  busTicketPurchaseOrder: "Bus ticket purchase order", //巴士购票订单
  busRescheduleOrder: "Bus reschedule order", //巴士改签订单
  busRefundOrder: "Bus refund order", //巴士退票订单
  openTicketSalesOrder: "Open ticket sales order", //open票销售订单
  openTicketSeatAssignmentOrder: "Open ticket seat assignment order", //open票取位订单
  busModifySignOrder: "Scan (Bus) to Modify/Sign Order", //巴士扫描改签订单
  busSeatBookingOrder: "Scan (Bus) for Seat Booking Order", //巴士扫描取位订单
  baggageTicketOrder: "Baggage Ticket Order", //行李票订单
  groupTicketOrder: "Group Ticket Order", //团体票订单
  freesTicket: "Free Ticket", //免费票
  agentInventoryOrder: "Agent inventory order", //代理库存订单
  inProgressStatus: "In progress", //进行中
  completedStatus: "Completed", //已完成
  cancelled: "Cancelled", //已取消
  toDate: "To", //至
  startDateSearch: "Start date", //开始日期
  endDateSearch: "End date", //结束日期
  allOptions: "All", //全部
  timedOutStatus: "Timed out", //已超时
  hourTimeUnit: "Hour", //时
  minuteTimeUnit: "Minute", //分
  advancedSearchButton: "Advanced", //高级
  resetButton: "Reset", //重置
  enabledStatus: "Enabled", //启用
  disabledStatus: "Disabled", //禁用
  noDataFound: "No data", //无数据
  conditionalSearch: "Conditional search", //条件搜索
  unitCode: "Unit code", //单位编号
  unitName: "Unit name", //单位名称
  operatingCompany: "Operating company", //运营公司
  search: "Search", //搜索
  city: "City", //城市
  parentUnit: "Parent unit", //上级单位
  selectOption: "Select", //选择
  selectStructure: "Select structure", //选择架构
  deactivated: "Deactivated", //已停用
  selectAffiliatedUnitTitle: "Select affiliated unit", //选择所属单位
  searchCriteriaEmptyError: "Search criteria cannot be empty", //搜索条件不能为空
  pleaseSelectManagementOrgMsg: "Please select a management organization", //请选择管理机构
  added: "Added", //已添加
  managementOrgCode: "Management organization code", //管理机构编号
  managementOrgName: "Management organization name", //管理机构名称
  addSelectedUnits: "Add selected units", //添加已勾选单位
  unitAlreadyAddedError: "This unit has already been added!", //此单位已添加！
  selectOnlyOneUnitMsg: "You may select only one unit at most", //最多选择一个单位
  notTraveledStatus: "Not traveled", //未乘车
  inTransitStatus: "In transit", //乘车中
  usedTicketStatus: "Used", //已使用
  ticketRefundedStatus: "Ticket refunded", //已退票
  expiredStatus: "Expired", //已过期
  partiallyRefundedStatus: "Partially refunded", //部分已退款
  noSeatAssignedStatus: "No seat assigned", //未取位
  pendingSeatAssignmentTicketNumberLabel:
    "Pending seat assignment ticket number", //待取位车票号
  clickToCopyToClipboardMsg: "Click to copy to clipboard", //点击可复制到剪切版
  pleaseEnterOrderNumberOrDateMsg:
    "Please enter the order number or select the order date", //请输入订单号或者选择下单日期
  ticketInquiryTitle: "Ticket inquiry", //车票查询
  batchPrintAction: "Batch print", //批量打印
  batchRefundAction: "Batch refund", //批量退票
  failedToObtainTicketNo: "Failed to obtain ticketNo", //获取ticketNo失败
  pleaseSelectTicketMsg: "Please select a ticket", //请选择车票
  thisTicketLabel: "This ticket", //该车票
  alreadyPrintedMsg: "Already printed, please select again", //已打印，请重新选择
  pleaseSelectMultipleTickets: "Please select multiple tickets", //请选择多项车票
  ticketStatusNotSupportRefund:
    "The selected ticket status does not support refunds", //选中车票状态不支持退票
  jointOperationNoRefund:
    "Joint-operation tickets are not eligible for refunds", //合营车票不支持退票
  ticketTypeOrStatusNoRefund:
    "The selected ticket type or ticket status does not support refunds", //选中车票类型或车票状态不支持退票
  oneWayOrRoundTrip: "One-way/ Round-trip", //单程/往返
  departureTimeHourMinute: "Departure time (hour and minute)", //开车时分
  departureStationManagement: "Departure station (management)", //出发站点(管理)
  arrivalStationManagement: "Arrival station (management)", //到达站点(管理)
  ticketPrice: "Ticket price", //票面价
  agentPrice: "Agent price", //代理价
  seatAssignmentAction: "Seat assignment", //取位
  refundReasonLabel: "Refund reason", //退票原因
  refundConfirmationMsg:
    'Click "Refund" to complete the refund. Tickets cannot be restored after a refund', //点击"退票"后,即完成退票,退票后车票不可恢复
  unlockAction: "Unlock", //解锁
  unlockSuccessful: "Unlock successfully", //解除锁定成功
  refundMethodLabel: "Refund method", //退款方式
  failedToObtainTicketNumber: "Failed to obtain ticket number", //获取车票号失败
  ticketDetailsLabel: "Ticket details", //车票详情
  seatReleaseAction: "Seat release", //消位
  printRefundVoucherAction: "Print refund voucher", //打印退票凭证
  printTicketAction: "Print ticket", //打印车票
  printTicketShort: "Print ticket", //印票
  cashCouponNameLabel: "Cash coupon name", //现金券名称
  cashCouponDiscountLabel: "Cash coupon discount", //现金券优惠
  salesPerson: "Sales person", //销售人员
  pricingInformationLabel: "Pricing information", //价格信息
  transactionTime: "Transaction time", //交易时间
  orderLabel: "Order", //订单
  cashCouponLabel: "Cash coupon", //现金券
  rescheduleOrSeatAssignment: "Reschedule/Seat assignment", //改签/取位
  passengerReschedulingFee: "Passenger rescheduling service fee", //乘客改签手续费
  noRefundForPassengerReschedule:
    "No balance will be refunded for passenger rescheduling", //乘客改签不退回差额
  noRefundForPassengerSeat:
    "No balance will be refunded for passenger seat assignment", //乘客取位不退回差额
  passengerRefundFee: "Passenger refund service fee", //乘客退票手续费
  agentReschedulingFee: "Agent rescheduling service fee", //代理改签手续费
  agentRefundFee: "Agent refund service fee", //代理退票手续费
  agentRefundProcessingFee: "Agent refund processing fee", //代理退票服务费
  regionalDiscountLabel: "Regional discount", //区域优惠
  monthlyCommissionLabel: "Monthly commission", //月结佣金
  promotionalDiscountLabel: "Promotional discount", //赠送优惠
  settlementPriceLabel: "Settlement price", //结算价
  ticketItineraryInfo: "Ticket itinerary information", //车票行程信息
  numberLabel: "No", //第
  segmentLabel: "Segment", //段行程
  failedToObtainTicketId: "Failed to obtain ticketId", //获取ticketId失败
  modificationCompletedMsg: "Modification completed", //修改完成
  editReasonLabel: "Edit reason", //修改原因
  enterModificationReason: "Please enter the reason for modification", //请输入修改原因
  seatCancellationReason: "Seat cancellation reason", //消位原因
  validityAfterCancellation: "Validity period after seat cancellation:", //消位后有效期：
  confirmSeatCancellation: "Confirm seat cancellation", //确定消位
  noSchedulesAtStation: "No schedules available at the current station", //当前站点无班次
  maxReschedulesReached: "The maximum number of reschedules has been reached", //已达到改签人数上限
  pricingRuleModified: "Pricing rule modified successfully", //修改价格规则成功
  reschedulingCompleted: "Rescheduling completed successfully", //已成功改签
  rescheduleOrderInfo: "Reschedule order information", //改签订单信息
  reschedulingFeeDetails: "Rescheduling fee details", //改签费用信息
  originalTicketNumber: "Original ticket number", //原票号
  originalTicketPrice: "Original ticket price", //原票价
  newTicketPrice: "New ticket price", //新票价
  ticketPriceDifference: "Ticket price difference", //票价差额
  reschedulingFee: "Rescheduling service fee", //改签手续费
  transactionTimeAndDate: "Transaction time/Transaction date", //交易时间/交易日期
  MainlandQRpayment: "Mainland - QR code payment", //内地-扫码支付
  Mainlandcardpayment: "Mainland - card payment", //内地-刷卡支付
  HongKongQRpayment: "Hong Kong - QR code payment", //香港-扫码支付
  HongKongcardpayment: "Hong Kong - card payment", //香港-刷卡支付
  ticketCountUnit: "Ticket(s)", //张
  TicketVerificationApp: "Ticket verification app", //验票app
  fullRefundRuleMsg:
    'This ticket is subject to the "original + complimentary ticket full refund" rule and will be fully refunded', //此车票绑定了"原票+赠票整批退"规则，即将整批退票
  routeNameLabel: "Route name", //路线名称
  refundAmountValue: "Refund amount", //退款金额
  reschedulePaymentAmount: "Reschedule payment amount", //改签支付金额
  yes: "Yes", //是
  no: "No", //否
  ticketValidationTimeLabel: "Ticket validation time", //验票时间
  expirationTimeLabel: "Expiration time", //过期时间
  refundTicketNumberLabel: "Refund ticket number", //退票车票号
  refundAmountLabel: "Refund amount", //退回金额
  managementOrg: "Management organization", //管理机构
  mobileNumber: "Mobile number", //手机号
  refundInProgressStatus: "Refund in progress", //退票中
  personalLogin: "Personal login", //个人登录
  orderQRCode: "Order QR code", //订单二维码
  coachMessage: "Coach message", //车辆信息
  QrCodeForBoarding: "QrCode For Boarding", //二维码乘车
  userCenter: "User center", //个人中心
  reportPreview: "Report preview", //报表预览
  intelligentSearch: "Intelligent search", //智能搜索
  businessAnalysis: "Business analysis", //经营分析
  userSystem: "User system", //用户体系
  noPageAvailable: "No page available", //暂无页面
  assetManagement: "Asset management", //资产管理
  ticketSalesInquiry: "Ticket sales inquiry", //查询售票
  openTicketSales: "Open ticket sales", //open票销售
  seatAssignmentReservation: "Seat assignment/reservation", //取位留位
  reservedTicketSales: "Reserved ticket sales", //预留票销售
  reservedOrderDetails: "Reserved order details", //预留订单详情
  handwrittenTicketSales: "Handwritten ticket sales", //手写票销售
  tourismProduct: "Tourism products", //旅游产品
  tourismProductSales: "Tourism products sales", //旅游产品销售
  tourismProductOrders: "Tourism products orders", //旅游产品订单
  tourismProductOrderDetails: "Tourism product order details", //旅游产品订单详情
  orderTicketManagement: "Order ticket management", //订单车票管理
  orderDetails: "Order details", //订单详情
  ticketRescheduling: "Ticket rescheduling", //车票改签
  smsManagement: "SMS management", //短信管理
  smsDetails: "SMS details", //短信详情
  reportManagement: "Report management", //报表管理
  settlementReport: "Settlement report", //结算报表
  groupTicketReport: "Group Ticket report", //团体票报表
  soldByOperator: "Sold by operator", //操作员售出
  refundRecords: "Refund records", //退票记录
  agentRevenueReport: "Agent revenue report", //代理营收报表
  agentInventoryReport: "Agent inventory report", //代理库存表
  businessReport: "Business report", //业务报表
  universalReportSales: "Universal report sales", //万能报表销售
  universalReportSeat: "Universal report seat", //万能报表取位
  appreciationRecord: "Appreciation record", //充值记录表
  balanceTransfer: "Balance transfer", //额度转移表
  prepaidReport: "Prepaid report", //预付款报表
  agentRemainingPrepaid: "Prepaid remaining balance", //代理剩余预付款
  agentRemainingPrepaidSummary: "Prepaid remaining summary", //预付款剩余汇总
  SelectPricingRule: "Select pricing rule", //选择价格规则
  selectOpenMsg:
    "Only the return open ticket operation can be selected simultaneously", //仅能同时选择返程open车票操作
  PleaseStation: "Please select station before searching", //请选择站点后查询
  viewReservation: "View reservation", //查看预留
  addTicketSales: "Add to ticket sales", //补入售票
  underVerification: "Under verification", //核查中
  pleaseConfirm: "Please confirm", //请确认
  cancelOrder: "Cancel order?", //是否取消下单
  pleasePay: "Please have the passenger make payment", //请让乘客支付
  returnTimeEarlierThanDepartureTime:
    "The return trip time is earlier than the departure trip time. Please rearrange the schedule.", //返程时间小于去程时间，请重新安排班次
  thisTicketIsBoundToTheRuleOf:
    'This ticket is subject to the "original + complimentary ticket full refund" rule and will be fully refunded', //此车票绑定了"原票+赠票整批退"规则，即将整批退票
  inReasonForModif: "Please fill in the reason for modification", //请填写修改原因
  agent: "Agent", //代理
  departureStation: "Departure station", //出发站点
  arrivalStation: "Arrival station", //到达站点
  autoFillNumber: " Auto-fill Ticket Number", //自动填充票号
  yuegangTicket: "Guangdong - Hong Kong Ticket", //粤港车票
  // ----------自己新增翻译----------
  currentSalesPrice: "Current sales price", //当前销售价格
  settlementTotalPrice: "Settlement total price", //结算总价
  allRealTimeAreas: "All real-time areas", //全部实时区域
  availableQuantityBeforeRecovery: "Available quantity - before recovery", //可用数量-回收前
  recoveryQuantity: "Recovery quantity", //回收数量
  availableQuantityAfterRecovery: "Available quantity - after recovery", //可用数量-回收后
  availableQuantityBeforeAllocation: "Available quantity - before allocation", //可用数量-分配前
  allocateQuantity: "Allocate quantity", //分配数量
  availableQuantityAfterAllocation: "Available quantity - after allocation", //可用数量-分配后
  allocationScheme: "Allocation scheme", //分配方案
  availableAmountChanging: "Available amount - changing", //可用数量-变动前
  availableAmountChang: "Available amount - chang", //可用数量-变动
  groupTicket_maxThreeDigits: "Up to 3 digits", //最多3位整数
  groupTicket_maxFiveTwo: "Up to 5 integer digits and 2 decimals", //最多5位整数2位小数
  groupTicket_amountGreaterThanZero: "Payment amount must be greater than 0", //付款金额需大于0
  salesSuccess: "Sales success", //销售成功
  noPrice: "No price at the current station", //当前站点无价格
  allocationSuccess: "Allocation success", //分配成功
  recoverySuccess: "Recovery success", //回收成功
  recoveryAmountExceedsAvailable:
    "The current recovery amount exceeds the available amount, please re-enter", //当前回收额超过可用总额，请重新输入
  transferSuccess: "Transfer success", //转移成功
  pleaseSelectSubAgentToTransfer: "Please select a sub-agent to transfer", //请选择子代理进行转移
  transferAmountExceedsAvailable:
    "The current transfer amount exceeds the available amount, please re-enter", //当前转移额超过可用总额，请重新输入
  pleaseSelectTransferOutSubAgent: "Please select a sub-agent to transfer out", //请选择转出子代理
  pleaseSelectTransferInSubAgent: "Please select a sub-agent to transfer in", //请选择转入子代理
  unitPrice: "Unit price", //单价
  rebookConfirm: "Reschedule confirmation", //改签确认
  reschedulePassengerInfo: "Reschedule Passenger Info", //"改签乘客信息"
  NotPrinted: "Not printed", //未打印
  Printed: "Printed", //已打印
  ticketNumberCopiedAndFilled:
    "Ticket number copied and filled in the search form!", //车票号已复制并填充至搜索表中！
  orderNumberCopiedAndFilled:
    "Order number copied and filled in the search form!", //订单号已复制并填充至
  clickToCopyOrderNumber: "Click to copy order number", //点击复制订单号
  passengerName: "Passenger name", //乘客姓名
  queryCondition: "Please enter at least one query condition", //请至少输入一个查询条件
  pleaseInTicketNo: "Please enter the ticket number", //请输入票号

  //查询售票页面
  lineDepartTime: "Line Departure time", // 班次始发时分
  seatStatus: "Seat status", //座位状态
  alightingPoint: "Alighting point", //下站点
  remarks: "Remarks", //备注
  ticketNo: "Ticket No.", //票号
  boarding: "Boarding", //上站
  alighting: "Alighting", //下站
  contactPerson: "Contact person", //联系人
  contactNumber: "Contact number", //联系电话
  operationType: "Operation type", //操作类型
  departureStationPassengerCount: "Departure station passenger count", //出发站点人数统计
  arrivalStationPassengerCount: "Arrival station passenger count", //到达站点人数统计
  departureCityArea: "Departure city/area", //出发城市/区域
  destinationCityArea: "Arrival city/area", // 到达城市/区域
  forenoon: "Forenoon", // 上午
  afternoon: "Afternoon", //下午
  evening: "Evening", //晚上
  serialS: "Srl", //序
  availableS: "Avl", //可
  soldS: "Sld", //售
  reserveS: "Rsvd", //留
  totalS: "Total", // 总
  firstLinesoldreserve: "First Line (Sold/Reserved)", //首段班次（已售/预留）
  station: "Station", // 站点
  printTime: "Print time", //打印时间
  print: "Print", //打印
  prePrint: "PrePrint", //预打印
  seatLog: "Seat Log", //座位日志
  status: "Status", //状态
  edit: "Edit", //编辑
  //预留票销售 Booking Ticket list
  ticketCollectorName: "Passenger name", //取票人姓名
  ticketCollectorContactWay: "Passenger contact information", //取票人联系方式
  reservationOperator: "Reservation operator", //操作预留人员
  reservationOperatTime: "Reservation operation time", //操作预留时间
  reservationTime: "Reservation time", //预留时间
  searchReservedTickets: "Enter ticket information for query", //输入预留票相关信息进行查询
  //预留票销售 Booking Ticket Details
  reserveDetails: "Reservation details", //预留详情
  cancelReserve: "Cancel reservation", //取消预留
  saleAction: "Sale", //销售
  reserveStore: "Reservation store", //预留门市
  busDepartureTime: "Bus departure time", //班次发车时间
  operationLogs: "Operation logs", //操作日志
  operateDetail: "Operation details", //操作详情
  confirmCancelReserve: "Confirm cancel reservation?", //确认取消预留座位？
  confirmExecuteSale: "Confirm execute sale?", //确认执行销售？
  lineCode: "Line code", //班次代码
  partialSaleConfirm: "not salable, still sell the salable part?", //不可销售，仍销售可售部分？
  allReservedNotSalable: "All reserved seat not salable", //预留座位均不可售
  // 手写票销售页面
  netAmount: "Total account Receivable", //应收总金额
  ticketSuccessMsg: "Ticket issued!", //出票成功！
  add2: "add", //添加
  fillInTicketSection: "Please enter free ticket segment", //请输入赠票票段
  issueTicket: "Issue ticket", //出票
  handwrittenTicket: "Handwritten ticket", //手写票
  freeTicket: "free ticket", //自由票
  // 旅游票确认表格新增字段
  // API旅游产品销售 API Product Pack Sale
  APIProductSale: "API tourism product sales", //API旅游产品销售
  fusionTab: "Fusion API tickets/packages", //融创API门票/套票
  disneyTab: "Disney API tickets/packages", //迪士尼API门票/套票
  chimelongTab: "Chimelong API tickets/packages", //长隆API门票/套票
  tourTab: "Self-owned products single sale/packages", //自有产品单售/套票
  hotelTab: "Hotel product packages", //酒店产品套票
  huafaTab: "Huafa API tickets/packages", //华发API门票/套票
  westkTab: "West Kowloon tickets/packages", //西九文化区门票/套票
  passengerInfoIncomplete: "Passenger {n} information is incomplete!", //第{n}位乘客信息填写不完整！
  certNoDuplicate: "Passenger certificate numbers cannot be duplicated!", //乘客证件号码不能重复！
  estimatedTotal: "Estimated total amount", //销售价合计
  fillCompleteInfo: "Please fill in complete order information!", //下单信息填写完整!
  fillCompleteCert: "Please fill in complete certificate information!", //证件信息填写完整!
  nameEnglishOnly: "Name must be in English only!", //姓名只能是英文!
  fillCompleteInfoAndName:
    "Please fill in complete order information or Name must be in English only!", //下单信息填写完整或姓名只能是英文!
  selectAtLeastOne: "Please select at least one product!", //产品至少选购一样!
  session: "Session", //场次
  price: "Price", //价格
  quantity: "Quantity", //数量
  inputPlaceholder: "--", //--
  cardNumberInput: "Please enter card numbers", //请输入卡号
  cardNumberInputLong: "Please enter card numbers, separated by commas", //请输入卡号,多个用英文逗号隔开
  returnDepartureTime: "Boarding time (return)", //上车时间(返程)
  productInfo: "Product Info", //产品信息
  commodityInfo: "Commodity Info", //商品信息
  commodityName: "Commodity Name", //商品名称
  commodityNo: "Commodity No.", //商品编号
  commodityOrderNo: "Commodity order No.", //商品订单号
  pleaseSelectCommodity: "Please select commodity!", //请选择商品!
  product: "Product", //产品
  email: "Email", //邮箱
  ticketInfo: "Ticket Info", //门票信息
  packageTicketCount: "Package Ticket Count", //套票张数
  remarksTraditional: "Remarks (Traditional)", //备注(繁)
  outboundBoardingPoint: "Outbound boarding point", //去程上站点
  outboundAlightingPoint: "Outbound alighting point", //去程下站点
  outboundDepartureDate: "Outbound departure date", //去程日期
  outboundDepartureTime: "Boarding time (outbound)", //上车时间(去程)
  returnBoardingPoint: "Return boarding point", //返程上站点
  returnAlightingPoint: "Return alighting point", //返程下站点
  returnDepartureDate: "Return departure date", //返程日期
  cardNo: "Card no", //卡号
  travelerInfo: "Traveler information", //出行人信息
  selectPOS: "Select POS machine", //POS机选择
  pleaseSelectPOS: "Please select POS machine", //请选择PSO机
  selectProduct: "Select product", //选择产品
  pleaseSelectProduct: "Please select product!", //请选择产品!
  pickupWay: "Pick up way", //领取方式
  activityName: "Activity name", //活动名称
  clickProductToChoose:
    "Without product or ID cannot issue ticket, please click product name to select", //未选择产品或无ID无法出票,请点击产品名称选择
  // 乘客信息录入
  seatLocked: "Seat locked", //已锁位
  seatNumReturn: "Seat number(Return)", //座位号（返程）
  pleaseEnterName: "please enter name", //请输入姓名
  pleaseEnterCardNo: "please enter card no", //请填写卡号
  checkCardNo:
    "The card no quantity is inconsistent with the purchase quantity, please check", //卡号数量与购买数量不一致，请检查
  browserVersionLow: "Browser version is too low", //浏览器版本低
  browserVersionLowPleaseUpdate:
    "Your browser version is too low to support the use of the browser serial port, please switch to the latest version of the browser", //您的浏览器版本太低，不支持浏览器串口的使用，请切换到最新版本浏览器
  packageTicket: "Package Ticket", //套票
  orderId: "Order ID", //订单ID
  productNo: "Product No.", //产品编号
  outboundReturn: "Outbound/Return", //去程/返程
  totalAmount: "Total amount", //合计金额
  // 旅游产品订单详情
  ticket: "Ticket", //门票
  busTicket: "Ticket",
  receipt: "Receipt", //收据
  consultationPhone: "Consultation Phone", //咨询电话
  phoneNumbers: "(Hong Kong) 29798778 (Mainland) 4008822322", //（香港）29798778 （内地） 4008822322
  download: "Download", //下载
  transactionType: "Transaction Type", //交易类型
  salesChannel: "Sales Channel", //销售渠道
  orderNumberAndSupplierOrderNo: "Order number/ Supplier Order No.", //订单号/供应商订单号
  supplierOrderNo: "Supplier Order No.", //供应商订单号
  isPackage: "Is Package", //是否套票
  packageName: "Package Name", //套票名称
  sourceOrderNo: "Source Order No", // 销售订单号
  printContent: "Print Content", //打印内容
  transactionNo: "Transaction No.", //交易流水号
  transactionMethod: "Transaction Method", //交易方式
  productCategory: "Product Category", //产品类别
  supplierName: "Supplier", //供应商
  cityName: "City Name", //所属城市
  validType: "Valid Type", //有效期类型
  effectiveDeadline: "Effective deadline", //有效截止日期
  productStatus: "Product Status", //商品状态
  costPrice: "Cost Price", //成本价
  productPrice: "Product Price", //商品价格
  sourceChannel: "Channel", //渠道
  validDays: "Number of effective days", //有效天数
  refundable: "refundable", //可退票
  modifySupplierOrderNo: "Modify Supplier Order No.", //修改供应商订单号
  failedToGetOrderNo: "Failed to get order No.", //获取订单号失败
  receiptGeneratingPleaseWait: "receipt is generating, please try again later", //收据生成中,请稍后再试
  generatingFailed: "Failed to get receipt", //收据生成失败
  noPrintableTicket: "No printable tickets ", //没有可打印的门票
  tourPackageProductOrder: "Tour Package Product Order",
  transactionDate: "Transaction Date", //交易日期
  baggageTicketDetails: "Baggage Ticket Details", // 行李票详情
  baggageTicketInfo: "Baggage Ticket Information", // 行李票信息
  BindTicketStatus: "Bind Ticket Status", //绑定车票状态
  getBaggageTicketFailed: "Failed to get baggage ticket number", //获取行李票号失败
  back: "Back", //返回
  organization: "Organization", //机构
  sendeAccount: "Sende Account", //发送账号
  user: "User", //用户
  userMobileNumber: "User mobile number", // 用户手机
  userEmail: "User Email", // 用户邮箱
  sendContent: "Send Content", //发送内容
  addSms: "Add SMS", //新增短信
  missingRequiredParams: "Missing required parameters", // 缺少必要的参数
  enterSMSInfoForQuery: "Enter SMS information for query", //输入短信相关信息进行查询
  enterOrderInfoForQuery: "Enter order information for query", //输入订单相关信息进行查询
  enterBaggageTicketInfoForQuery: "Enter baggage ticket information for query", //输入行李票相关信息进行查询
  smsSentSuccessfully: "SMS sent successfully", //短信已发送成功
  emailSentSuccessfully: "Email sent successfully", //邮件已发送成功
  resendSms: "Resend SMS", //重发短信
  resendEmail: "Resend Email", //重发邮件
  //扫描车票页面
  sheet: "No of ticket: ", //(共xx)张票
  adultTicket: "Adult ticket", // 成人票
  seat: "Seat", // 座位
  boardingLocation: "Boarding location", // 上车地点
  alightingLocation: "Alighting location", // 下车地点
  address: "Address", // 地址
  intermediateBoardingLocation: "Intermediate boarding location", // 中途上车地点
  serviceProvider: "Service provider", // 服务供应商
  noValidTicketsFound: "No valid ticket within the order", // 我们没有找到订单内有效的车票
  ticketTipsTtem1:
    "To ensure smooth boarding, please arrive at the station 15 minutes in advance; if you have any issues, please contact our staff", // 1.为了乘车顺利，请提前15分钟到站等车，如有问题请联系站点工作人员
  ticketTipsTtem2:
    "To avoid crowding, boarding for trips from Shenzhen Bay Port to Hong Kong will be first come, first served", // 2.为了避免人员聚集，深圳湾口岸至香港班次先到先乘车
  seoIndexKeywords: "trans-island chinalink hk ticket", //環島中港通 香港 車票 -- 说明：seo关键字，和官网一样只需要繁体字
  failedToObtainTicketInfo: "Failed to obtain ticket info", //获取车票信息失败
  //打印预览页面
  loading: "Loading", // 加载中
  printPreview: "Print preview", // 打印预览
  disneyTicketPreview: "Disney ticket preview", // 迪士尼门票预览
  disneyPackagePreview: "Disney package preview", // 迪士尼套票预览
  chimelongTicketPreview: "Chimelong ticket preview", // 长隆门票预览
  chimelongPackagePreview: "Chimelong package preview", // 长隆套票预览
  fusionTicketPreview: "Fusion ticket preview", // 融创门票预览
  fusionPackagePreview: "Fusion package preview", // 融创套票预览
  freeProductPackagePreview: "Free product package preview", // 自由产品套票预览
  hotelPackagePreview: "Hotel package preview", // 酒店套票预览
  huafaTicketPreview: "Huafa ticket preview", // 华发门票预览
  huafaPackagePreview: "Huafa package preview", // 华发套票预览
  selfowndProductSingleTicketPreview:
    "Self-owned Products single ticket preview", // 自有产品单票预览
  //旅游产品打印&确认
  orderCancelled: "The order has been canceled", //订单已取消
  orderCancelFailed: "Order cancellation failed", //订单取消失败
  bookDate: "Booking date", // 预定日期
  ticketTypeL: "Ticket type", // 门票类型
  validityPeriod: "Validity period", // 有效期
  departureTime: "Departure time", // 出发时间
  parentManagementOrg: "Parent management organization", //上级管理机构
  pleaseSelectSchedule: "Please select schedule for operation", //请选中班次后操作
  pleaseReselectCity: "Please reselect city, cannot choose city not owned", //请重新选择城市，无法选择，未拥有的城市
  refundF: "Refund ", //退款
  refundSuccessful: "Refund successfully", //退款成功
  refundReason: "Refund reason ", //退款原因
  pleaseEnterRefundReason: "Please enter refund reason ", //请输入退款原因
  reservation: "Reservation", //预留
  reserve2hours: "Reserved for 2 hours", //  预留2小时
  reserved12hours: "Reserved for 12 hours", //  预留12小时
  reserveduntil24hBefore: "Reserved until 24 hours before departure", //  预留至发车前24小时
  reservedNoLimit: "Reservation with no time limit", //  不限时预留
  pleaseEnterIdNo: "Please enter identification number", //请输入证件号码
  notPrinted: "Not printed", //未打印
  retrieveCardCode: "Retrieve card code", //取卡串码
  querying: "Querying", //获取中
  startPrint: "Start printing tickets", //开始打票
  totalRefundAmount: "Total refund ticket amount", //总退票金额
  totalRefundSettleAmount: "Total refund settle amount", //总退票结算金额
  settleUnitName: "Settle unit name",
  saleAccountName: "Sale account name",
  pleaseEnterRefundNote: "Please enter refund note", //请输入退票备注
  pleaseWaitForTerminalTransaction: "Please wait for terminal transaction", //请等待终端交易
  pleaseCompleteBaggageTicketInfo: "Please complete baggage ticket info",
  placingOrder: "Placing an order",
  baggageOrSupplementTicketDetail: "Baggage or supplement ticket detail",
  baggageOrSupplementTicketInfo: "Baggage or supplement ticket info",
  baggageOrSupplementTicketRefund: "Baggage or supplement ticket refund",
  baggageOrSupplementTicketQuery: "Baggage or supplement ticket query",
  supplementTicketSales: "Supplement ticket sales",
  refundTicket: "Refund ticket",
  refundNote: "Refund note",
  supplementTicket: "Supplement ticket",
  supplementBaggageTicket: "Supplement baggage ticket",
  itinerary: "Itinerary",
  seatAssignmentSuccess: "Seat assignment successful",
  // 打印ts文件
  transactionVoucher: "Transaction voucher", //交易凭证
  booker: "booker", //预定人
  actualCollection: "Actual collection", //实收款
  hotelCity: "Hotel city", //酒店城市
  hotelName: "Hotel name", //酒店名称
  hotelAddress: "Hotel address", //酒店地址
  noRefundsForReschedule: "No refunds for reschedule", //改签不退回
  zhuhaiPort: "Zhuhai Port", //珠海口岸
  macauSectionFree: "Macau section free", //澳门段免费
  travelDate: "Travel date", //乘车日期
  refundFare: "Refund fare", //退回票款
  refundPaymentMethod: "Refund payment method", //退票支付方式
  modifySuccess: "Modify success", //修改成功
  plsDownloadWithAndroid: "Please download with Android phone", //请使用安卓手机下载
  scheduleNotChoosed: "Schedule not choosed", //未选中班次
  failedToGetDllData: "Failed to get dll data", //获取dll数据失败
  tscPrinter: "Desktop printer", //台式打印机
  hotelPersonNums: "Hotel Person Nums", //入住人数
  confirmEmptyQueryCondition: "Confirm to empty all the query conditions?", //确认清空所有查询条件么？
  currentDepartureJourney: "Current departure journey", // 当前去程
  confirmFetchBtn: "Confirm fetch", //确认取位
  selectOpenMsg2:
    "Only the return open ticket operation can be selected simultaneously", //仅能同时选择返程open车票操作
  deleteAll: "Delete all", //全部删除
  view_ticket_prices: "View ticket prices", //查看票价
  faceValue: "face value", // 票面价
  discount: "discount", // 优惠
  // Receipt related translations
  receiptTitle: "Trans-Island ChinaLink Cross-Border Bus Receipt",
  reimbursementNote: "Available for reimbursement",
  ticketTypeReceipt: "Ticket Type",
  ticketCategoryReceipt: "Category",
  hkPhone: "(Hong Kong) 29798778",
  mainlandPhone: "(Mainland) 4008822322",
  ticketNumberReceipt: "Ticket Number",
  passengerNameReceipt: "Passenger Name",
  departureStationReceipt: "Departure Station",
  arrivalStationReceipt: "Arrival Station",
  departureTimeReceipt: "Departure Time",
  validDate: "Valid Date",
  seatNumberReceipt: "Seat Number",
  ticketPriceReceipt: "Ticket Price",
  serviceProviderReceipt: "Service Provider",
  consultationPhoneReceipt: "Consultation Phone",
  openBusExpireTime: "Expire Time",
  orderNo: "Order No.",
  useDate: "Use Date",
  guest: "Guest",
  prepaymentFlow: "prepayment Flow",
  changeAmount: "change Amount",
  outAccount: "out Account",
  toAccount: "to Account",
  seatHoldStats: "seat Hold Stats", // 取位留位人数统计
  tourProductDetail: "Tour Product Detail", // 旅游产品详情
  transferStationNotice:
    "Note: One trip in the order is a long-distance ticket, and the other is a port ticket!",
};
